import { BaseDSLVisitor } from './baseDSL.visitor';
import { FunctionPlainObject } from '../plainObjects/function.plainObject';

/* eslint-disable @typescript-eslint/no-explicit-any */
export class FunctionsVisitor extends BaseDSLVisitor {

    constructor(protected _tokenStream: any, public functions: FunctionPlainObject[]) {
        super(_tokenStream);
    }

    public visitFunctions(context: any): void {
        this.visitChildren(context);
    }

    public visitFunctionDefinition(context: any): void {
        const func = new FunctionPlainObject();
        func.name = context.fnName.getText();
        func.paramTypes = context.datatype().map((paramType: any) => paramType.getText());
        func.returnType = context.ret.getText();
        const literal = context.extension_literal();
        if (literal) {
            func.className = literal.getText();
        }
        const expression = context.expression();
        if (expression) {
            func.expression = this._getText(expression);
        }
        this.functions.push(func);
    }
}
